// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3wCC0","rootCenter":"LoadMoreObserver_rootCenter__m0iEE","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3EGGE"};